import { pathOr } from 'ramda'
import { useMemo } from 'react'
import { Message } from 'types/message'

const useIsBotMessage = (message?: Partial<Message>): boolean =>
  useMemo(() => pathOr(false, ['attributes', 'isBot'], message), [message])

export default useIsBotMessage
